import ActiveTag from "@components/common/ActiveTag";
import useAppContext from "@hooks/useAppContext";
import { ITag } from "@modules/requestAQuote/components/TripPreferences";

interface IProps {
  title?: string;
  tags: ITag[];
  handleRemoveTag?: (tagData: string, tagType: string) => void;
}

const TripPreferencesDetailSection = ({
                                        title,
                                        tags,
                                        handleRemoveTag,
                                      }: IProps): JSX.Element => {
  const { isMobile } = useAppContext();
  return (
    <div className="flex flex-col">
      <span className="my-1 text-p font-medium text-black">{title}</span>
      {tags?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {tags?.map((tag) => {
            return (
              <ActiveTag
                key={
                  tag.title
                    ? `${tag.id}${tag.title}`
                    : `${tag.id}${tag?.Title ?? ""}`
                }
                tagData={tag}
                onClick={!tag.notRemovable && (handleRemoveTag as any)}
                isFormB={true}
              />
            );
          })}
        </div>
      ) : (
        <span className="text-p14 text-darkgray">No preference</span>
      )}
    </div>
  );
};

export default TripPreferencesDetailSection;
